import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { StoreProvider } from "@/context/StoreContext";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Orders from "@/pages/Orders";
import Admin from "@/pages/Admin";
import Concerns from "@/pages/Concerns";
import ConcernDetail from "@/pages/ConcernDetail";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import InfoPage from "@/pages/InfoPage";
import Register from "@/pages/Register";
import Billing from "@/pages/Billing";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/order-success/:id" element={<OrderSuccess />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/concerns" element={<Concerns />} />
          <Route path="/concerns/:id" element={<ConcernDetail />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogDetail />} />
          <Route path="/about" element={<InfoPage pageKey="about" />} />
          <Route path="/terms" element={<InfoPage pageKey="terms" />} />
          <Route path="/contact" element={<InfoPage pageKey="contact" />} />
          <Route path="/register" element={<Register />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </StoreProvider>
  );
}

export default App;
